import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
// import Alert from "@mui/material/Alert";
// import Snackbar from "@mui/material/Snackbar";
import { useLocation, useNavigate } from "react-router";
// import { editfaqs, editsubcategorylist } from '../../service/Mainservice';
import Loader from "../../Loader/Loader";
// import { editfaqs } from "../../service/Mainservice";
import { Link } from "react-router";

const validate = (values, isInitialLoad) => {
  const errors = {};
  if (isInitialLoad) return errors;

  if (!values.que) {
    errors.que = "Required";
  }
  if (!values.ans) {
    errors.ans = "Required";
  }
  return errors;
};

const Editfaqs = () => {
  const [load, setload] = useState(false);
  const [success, setsuccess] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open, setOpen] = useState(false);
  const [err, seterr] = useState("");
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();
  const items = location.state.item;
  console.log(location);

  useEffect(() => {
    formik.setValues(
      {
        que: items.question,
        ans: items.answer,
      },
      false
    );
    formik.validateForm();
  }, [items]);

  const formik = useFormik({
    initialValues: {
      que: "",
      ans: "",
    },
    validate: (values) => validate(values, isInitialLoad),
    onSubmit: (values) => {
      // handleAdd(values);
    },
  });

  // const handleAdd = async (values) => {
  //   setload(true);
  //   try {
  //     const response = await editfaqs(items.id, values.que, values.ans);
  //     setsuccess(response.data.message);
  //     setOpen2(true);
  //     setload(false);
  //   } catch (error) {
  //     seterr(error.message);
  //     setOpen(true);
  //     setload(false);
  //   }
  // };

  return (
    <>
      {" "}
      <div className="Naviagtion_links">
        <Link
          activeClassName="active_nav"
          className="navigation_text"
          to={"/FAQS_List"}
        >
          FAQS List
        </Link>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="19"
          viewBox="0 0 24 24"
          fill="var(--black)"
        >
          <g clip-path="url(#clip0_103_422)">
            <path
              d="M12.1718 12L9.34277 9.17199L10.7568 7.75699L14.9998 12L10.7568 16.243L9.34277 14.828L12.1718 12Z"
              fill="var(--textheading)"
            />
          </g>
          <defs>
            <clipPath id="clip0_103_422">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <Link to="/Edit_FAQS" className="navigation_text active_nav">
          Edit FAQS
        </Link>
      </div>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">Edit FAQS</h1>
        </div>
        <form onSubmit={formik.handleSubmit} className="interview_form">
          <div>
            <label className="Auth_label">Question</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="que"
              type="text"
              minLength={1}
              maxLength={200}
              value={formik.values.que}
              className="Auth_input"
            />
            {formik.errors.que ? (
              <p className="invalid">{formik.errors.que} </p>
            ) : null}
          </div>
          <div>
            <label className="Auth_label">Answer</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="ans"
              type="text"
              minLength={1}
              maxLength={200}
              value={formik.values.ans}
              className="Auth_input"
            />
            {formik.errors.ans ? (
              <p className="invalid">{formik.errors.ans} </p>
            ) : null}
          </div>
          <div />

          <button className="term_button" type="Submit">
            Save
          </button>
        </form>
      </div>
      {load && <Loader />}
      {/* <Snackbar
        open={open}
        autoHideDuration={2000}
        onClose={() => setOpen(false)}
      >
        <Alert severity="error" variant="filled" sx={{ width: "70vw" }}>
          {err}
        </Alert>
      </Snackbar>
      <Snackbar
        open={open2}
        autoHideDuration={2000}
        onClose={() => setOpen2(false)}
      >
        <Alert severity="success" variant="filled" sx={{ width: "70vw" }}>
          {success}
        </Alert>
      </Snackbar> */}
    </>
  );
};
export default Editfaqs;
